import { StyleSheet, Text, View, ViewStyle } from "react-native";
import { Colors, Typography } from "../../styles";

const CaughtUp = () => {
  const Dots = ({ style }: { style?: ViewStyle }) => (
    <View style={[styles.dots, style]}>
      <View style={styles.dot} />
      <View style={styles.dot} />
      <View style={styles.dot} />
    </View>
  );
  return (
    <View style={styles.container}>
      <Dots />
      <Text style={[Typography.paragraph, styles.title]}>
        You're all caught up
      </Text>
      <Text style={[Typography.paragraph, styles.paragraph]}>
        You've seen all new insights from the past day
      </Text>
      <Dots style={{ opacity: 0.3 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    marginVertical: 30,
  },
  dots: { height: 25, justifyContent: "space-between", marginVertical: 20 },
  dot: {
    width: 2.5,
    height: 2.5,
    borderRadius: 2.5 / 2,
    backgroundColor: Colors.white,
  },
  title: { fontSize: 18 },
  paragraph: {
    opacity: 0.5,
    maxWidth: 250,
    textAlign: "center",
  },
});

export default CaughtUp;
